<div id="merchant-table">
  <app-ep-table [config]="config" [data]="merchants$ | async" data-cy="merchants-table"></app-ep-table>
</div>
